import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OpenAPIService } from '../lib/api/openApi';
import { City, Country, State } from '../types/openApi';
import { AppDispatch } from './index';

type InitialStateType = {
    loading: boolean;
    countriesData: Country[] | null;
    countries: Country[] | null;
    states: State[] | null;
    city: City[] | null;
};

const initialState: InitialStateType = {
    loading: true,
    countriesData: null,
    countries: null,
    states: null,
    city: null,
};

const phoneCodeSlice = createSlice({
    name: 'phoneCode',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setCountriesData(state, action: PayloadAction<Country[]>) {
            state.countriesData = action.payload;
        },
        setCountries(state, action: PayloadAction<Country[]>) {
            state.countries = action.payload;
        },
        setStates(state, action: PayloadAction<State[]>) {
            state.states = action.payload;
        },
        setCities(state, action: PayloadAction<City[]>) {
            state.city = action.payload;
        },
    },
});

export const getCountryAndPhoneCode = () => {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(phoneCodeSlice.actions.setLoading(true));

            const data = await OpenAPIService.fetchCountriesWithPhoneCode();

            if (data) {
                dispatch(phoneCodeSlice.actions.setCountriesData(data));
            }
        } catch (err) {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        } finally {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        }
    };
};

export const getCountries = () => {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(phoneCodeSlice.actions.setLoading(true));

            const data = await OpenAPIService.fetchCountriesWithPhoneCode();

            if (data) {
                dispatch(phoneCodeSlice.actions.setCountriesData(data));
            }
        } catch (err) {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        } finally {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        }
    };
};

export const getStates = (Iso2CountryString: string) => {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(phoneCodeSlice.actions.setLoading(true));

            const data = await OpenAPIService.fetchAllStates();

            if (data) {
                dispatch(phoneCodeSlice.actions.setStates(data));
            }
        } catch (err) {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        } finally {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        }
    };
};

export const getCities = (iso2CountryString: string, iso2StateString: string) => {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(phoneCodeSlice.actions.setLoading(true));

            const data = await OpenAPIService.fetchCitiesByStateAndCountry(iso2CountryString, iso2StateString);

            if (data) {
                dispatch(phoneCodeSlice.actions.setCities(data));
            }
        } catch (err) {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        } finally {
            dispatch(phoneCodeSlice.actions.setLoading(false));
        }
    };
};

export default phoneCodeSlice.reducer;
export const { setLoading } = phoneCodeSlice.actions;
